import { CalculateKinds } from "..";
import { ICalculatedValueValidatable, instanceOfICalculatedValueValidatable } from "./ICalculatedValueValidatable";

export interface ICompareDateValidatable extends ICalculatedValueValidatable {
  calculateKind: CalculateKinds;
  isCompareDateEmptyCheckEnable: boolean;
  text(): string;
}

export function instanceOfICompareDateValidatable(instance: any): instance is ICompareDateValidatable {
  if (!instance) { return false; }
  return (instance.calculateKind === CalculateKinds.CompareDate)
    && (instance.isCompareDateEmptyCheckEnable !== undefined)
    && (instance.text !== undefined)
    && instanceOfICalculatedValueValidatable(instance);
}
